<template>
<div class="animated fadeIn mt-5">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row justify-content-center">
      <div class="col-md-6">
        <b-card>
          <div slot="header">
            <strong>Item</strong>
          </div>
          <b-form-fieldset label="Código">
            <b-form-input type="text" name="name" v-model="item.name" placeholder="Código"  v-validate="'required'" :state="validateState('name')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('name') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <b-form-fieldset label="Nome">
            <b-form-input type="text" name="display_name" v-model="item.display_name" placeholder="Nome"  v-validate="'required'" :state="validateState('display_name')"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors.first('name') }}
            </b-form-invalid-feedback>
          </b-form-fieldset>
          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'roles.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>

        <b-card class="mt-5">
          <div slot="header">
            <strong>Grupos</strong>
          </div>
          <b-form-checkbox-group id="permissions" name="permissions" v-model="item.permissions_list">
            <b-row>
              <b-col sm="6" md="4" class="mb-4" v-for="pgroup in permissionGroups">
                <h6>{{ pgroup.name }}</h6>
                <div v-for="permission in pgroup.permissions.data" :key="permission.id">
                  <b-form-checkbox :value="permission.id">{{permission.display_name}}</b-form-checkbox>
                </div>
              </b-col>
            </b-row>
          </b-form-checkbox-group>

        </b-card>


        <b-card class="mt-5">
          <div slot="header">
            <strong>Categorias</strong>
          </div>
          <b-form-checkbox-group id="mpg" name="mpg" v-model="item.product_categories">
            <div v-for="mpg in mpg_list" :key="mpg.id">
              <b-form-checkbox :value="mpg.id">{{mpg.name}}</b-form-checkbox>
            </div>
          </b-form-checkbox-group>

        </b-card>

      </div>
      <!--/.col-->
    </div>
  </form>
</div>
</template>

<script>
export default {
  name: 'UsersEdit',
  props: ['id'],
  data() {
    return {
      showTeam: false,
      showPassword: false,
      item: {
        name: '',
        display_name: '',
        product_categories: []
      },
      permissionGroups: [],
      mpg_list: []
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$toastr('error', 'Tem campos inválidos', 'Erro')
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      if (this.item.id) {
        this.axios.put('admin/roles' + '/' + this.item.id, data)
          .then(response => {
            this.item = response.data.data
            this.$toastr('success', 'item gravado com sucesso', 'Gravado')
            if (close) {
              this.$router.push({
                name: 'roles.index'
              })
            }
          })
          .catch(response => {
            this.$toastr('error', 'Não foi possivel gravar', 'Erro')
          })
      } else {
        this.axios.post('admin/roles', data)
          .then(response => {
            this.item = response.data.data
            this.$toastr('success', 'item gravado com sucesso', 'Gravado')
            this.$router.push({
              name: 'roles.edit',
              params: {
                id: this.item.id
              }
            })
          })
          .catch(response => {
            this.$toastr('error', 'Não foi possivel gravar', 'Erro')
          })
      }
    }
  },
  created() {
    var id = this.$route.params.id
    if (typeof id !== 'undefined') {
      this.axios.get('admin/roles' + '/' + id)
        .then(response => {
          this.item = response.data.data
          if (typeof this.item.product_categories === 'undefined') {
            this.item.product_categories = []
          }
        })
        .catch(response => {
          this.$toastr('error', 'Este utilizador não existe', 'Erro')
          this.$router.push({
            name: 'roles.index'
          })
        })
    }
    this.axios.get('admin/permissions/lst').then(response => {
      this.permissionGroups = response.data.data
    })
    this.axios.get('product_categories/lst').then(response => {
      this.mpg_list = response.data.data
    })
  }
}
</script>



// WEBPACK FOOTER //
// edit.vue?638ae7b0